export const FETCH_STOCK_FILES = 'FETCH_STOCK_FILES';
export const SET_STOCK_FILES = 'SET_STOCK_FILES';
export const GET_STOCK_FILES = 'GET_STOCK_FILES';
export const SET_LOADING_STOCK_FILES = 'SET_LOADING_STOCK_FILES';
export const GET_LOADING_STOCK_FILES = 'GET_LOADING_STOCK_FILES';
